import React from "react";
import { Typography, Box, List, ListItem, ListItemText, Divider, Grid, Button, Chip } from "@mui/material";
import "./expected-behaviour.css";

const ExpectedBehaviour = ({ nextStep }) => {
  const rules = [
    "Show everyone respect",
    "Do not behave in a way that offends, threatens or hurts anybody",
    "Listen to staff requests",
    "Follow the daily routine",
    "Be positive where possible, if you feel in a low mood please seek staff to talk to and support you",
    "Do not damage any items",
    "Do not do anything that is considered a crime",
    "Bullying is not allowed",
    "Sexualized behavior is not acceptable",
    "Racism in any form is not allowed",
    "Fire alarms and safety equipment are not to be touched",
    "Office spaces are for staff only",
  ];

  return (
    <Box className='house-rules-container'>
      <Box className='header-section-house'>
        <Chip label='Admission' />
        <Grid container spacing={1}>
          <Grid item>
            <Typography sx={{ fontSize: "22px", fontWeight: "bold", color: "black" }} align='left' mt={1}>
              House Rules
            </Typography>
          </Grid>
          <Grid item>
            <Typography sx={{ fontSize: "22px", fontWeight: "bold", color: "#1751D0" }} align='left' mt={1}>
              Little Norway{" "}
            </Typography>
          </Grid>
        </Grid>
        <br />
        <Divider className='divider' />
      </Box>
      <Box className='content-section'>
        <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: "black" }} align='left'>
          Expected Behaviour
        </Typography>
        <Typography sx={{ fontSize: "14px" }}>
          "Show respect to everyone in the home, follow staff guidance, and maintain a positive and <br />
          supportive attitude toward others."
        </Typography>
        <List className='rules-list'>
          {rules.map((rule, index) => (
            <ListItem key={index} className='rule-item'>
              <ListItemText primary={<Typography sx={{ fontSize: "14px", color: "black" }}>{rule}</Typography>} />
            </ListItem>
          ))}
        </List>
      </Box>
      <Box mt={3}>
        <Grid item xs={12}>
          <div className='submit-button-container'>
            <Button type='button' variant='contained' color='primary' className='submit-button' onClick={nextStep}>
              Next
            </Button>
          </div>
        </Grid>
      </Box>
    </Box>
  );
};

export default ExpectedBehaviour;
